import { render, staticRenderFns } from "./SelecaoMarcacao.vue?vue&type=template&id=8bb360be&"
import script from "./SelecaoMarcacao.vue?vue&type=script&lang=js&"
export * from "./SelecaoMarcacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports